import { Link } from "react-router-dom";
import { Radar, ArrowRight } from "lucide-react";
import { homeTrack } from "../shared";

const RadarVisual = () => (
  <svg viewBox="0 0 200 200" role="img" aria-label="Regulatory radar visualization tracking US, EU, Asia and global jurisdictions"
    className="w-full max-w-[230px] mx-auto">
    <defs>
      <radialGradient id="nlRadarBg" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#00E5FF" stopOpacity="0.10" />
        <stop offset="70%" stopColor="#00E5FF" stopOpacity="0.03" />
        <stop offset="100%" stopColor="#00E5FF" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="nlRadarBeam" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#00E5FF" stopOpacity="0.28" />
        <stop offset="100%" stopColor="#00E5FF" stopOpacity="0" />
      </linearGradient>
    </defs>
    <circle cx="100" cy="100" r="92" fill="url(#nlRadarBg)" />
    {[92, 68, 44, 20].map((r) => (
      <circle key={r} cx="100" cy="100" r={r} fill="none" stroke="#00E5FF" strokeOpacity={r === 92 ? 0.28 : 0.14} strokeWidth="1" />
    ))}
    <line x1="8" y1="100" x2="192" y2="100" stroke="#00E5FF" strokeOpacity="0.10" strokeWidth="1" />
    <line x1="100" y1="8" x2="100" y2="192" stroke="#00E5FF" strokeOpacity="0.10" strokeWidth="1" />
    <line x1="35" y1="35" x2="165" y2="165" stroke="#00E5FF" strokeOpacity="0.06" strokeWidth="1" />
    <line x1="165" y1="35" x2="35" y2="165" stroke="#00E5FF" strokeOpacity="0.06" strokeWidth="1" />
    <g className="nl-radar-sweep">
      <path d="M100 100 L100 8 A92 92 0 0 1 152 24 Z" fill="url(#nlRadarBeam)" />
      <line x1="100" y1="100" x2="100" y2="8" stroke="#00E5FF" strokeOpacity="0.55" strokeWidth="1.4" />
    </g>
    <circle cx="64" cy="70" r="3.4" fill="#00E5FF" className="nl-radar-blip" />
    <circle cx="138" cy="58" r="2.8" fill="#A78BFA" className="nl-radar-blip" style={{ animationDelay: "1.1s" }} />
    <circle cx="128" cy="136" r="3" fill="#00E5FF" className="nl-radar-blip" style={{ animationDelay: "2.2s" }} />
    <circle cx="76" cy="146" r="2.4" fill="#34D399" className="nl-radar-blip" style={{ animationDelay: "0.6s" }} />
    <text x="52" y="62" fill="#5f7681" fontSize="7.5" fontFamily="monospace" letterSpacing="1">US</text>
    <text x="146" y="52" fill="#5f7681" fontSize="7.5" fontFamily="monospace" letterSpacing="1">EU</text>
    <text x="136" y="148" fill="#5f7681" fontSize="7.5" fontFamily="monospace" letterSpacing="1">ASIA</text>
    <text x="44" y="160" fill="#5f7681" fontSize="7.5" fontFamily="monospace" letterSpacing="1">GLOBAL</text>
    <circle cx="100" cy="100" r="2.6" fill="#00E5FF" />
  </svg>
);

export const RegulationRadarCard = () => (
  <aside data-testid="premium-radar-panel"
    className="relative flex flex-col sm:max-xl:flex-row xl:flex-col gap-5 rounded-xl border border-[#00E5FF]/[0.22] bg-[#071018] overflow-hidden p-5 motion-safe:transition-colors hover:border-[#00E5FF]/[0.38]">
    <div aria-hidden className="absolute -bottom-20 -right-16 h-56 w-56 rounded-full pointer-events-none"
      style={{ background: "radial-gradient(circle, rgba(0,229,255,0.10), transparent 70%)" }} />
    <div className="relative sm:max-xl:flex-1 min-w-0">
      <h3 className="flex items-center gap-2 font-heading font-bold text-white text-[17px]">
        <Radar className="h-[18px] w-[18px] text-[#00E5FF]" aria-hidden /> Regulation Radar
      </h3>
      <p className="text-[12.5px] text-gray-400 leading-relaxed mt-2.5">
        The weekly regulatory intelligence briefing, exclusively for members.
      </p>
      <Link to="/radar" data-testid="premium-radar-link" onClick={() => homeTrack("premium_section", "/radar")}
        className="group mt-4 inline-flex items-center gap-2 rounded-lg border border-[#00E5FF]/50 bg-[#00E5FF]/[0.06] px-4 py-2 text-[12.5px] font-bold text-[#00E5FF] motion-safe:transition-colors hover:bg-[#00E5FF]/[0.14] hover:border-[#00E5FF]/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00E5FF]/60">
        Browse the Radar archive
        <ArrowRight className="h-3.5 w-3.5 motion-safe:transition-transform motion-safe:duration-200 group-hover:translate-x-1" aria-hidden />
      </Link>
    </div>
    <div className="relative sm:max-xl:w-[240px] xl:mt-auto shrink-0" data-testid="premium-radar-visual">
      <RadarVisual />
    </div>
  </aside>
);
